import { Disposicion } from './../../../models/disposicion.model';
import { Component, } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-disposicion",
    templateUrl: "./disposicion.component.html",
    styleUrls: ["./disposicion.component.css"],
    providers: [FormService]
})

export class DisposicionComponent {
      public rows = [];
      public actualRow;
      public disposicion: Disposicion;
      public form;
      public matcher = new FormService();

      constructor(private fb: FormBuilder, private dialog: MatDialog){
        this.form = new FormGroup({
            disposicion1: new FormControl('', Validators.required),
            disposicion2: new FormControl('', Validators.required),
            disposicion3: new FormControl('', Validators.required),
            disposicion4: new FormControl('', Validators.required)            
        })
        if(!JSON.parse(localStorage.getItem("disposicion"))){
            localStorage.setItem("disposicion", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("disposicion"));
            this.form.controls['disposicion1'].setValue(this.rows[0]?this.rows[0].disposicion1:false);
            this.form.controls['disposicion2'].setValue(this.rows[0]?this.rows[0].disposicion2:false);
            this.form.controls['disposicion3'].setValue(this.rows[0]?this.rows[0].disposicion3:false);
            this.form.controls['disposicion4'].setValue(this.rows[0]?this.rows[0].disposicion4:false);
            
        }

        this.disposicion = {disposicion1:'',disposicion2:'',disposicion3:'',disposicion4:''};
    }

    add_disposicion(){
        localStorage.setItem("disposicion",JSON.stringify([]));
        this.actualRow = localStorage.getItem("disposicion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            disposicion1: this.form.value.disposicion1,
            disposicion2: this.form.value.disposicion2,
            disposicion3: this.form.value.disposicion3,
            disposicion4: this.form.value.disposicion4            
        })
        localStorage.setItem("disposicion", JSON.stringify(this.rows));
    
    }

    delete_disposicion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("disposicion", JSON.stringify(this.rows));
            }
        }
    }

}